export const company =
{
    name: 'Ella Marriot Jansud Realty',
    welcomeName: 'Ella Marriot Jansud Realty',
    mainServiceArea: 'Hua Hin',
    navPhone: '',
    phone1: '',
    phone2: '',
    email: 'contact@email.com',
    address1: '',
    address2: '',
    address3: '',
    phoneUrl: '',
    lineUrl: '',
    lineId: '',
    whatsappUrl: '',
    // whatsappUrl: '',
    youtubeUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    tiktokUrl: '',
    linkedInUrl: ''
}
